import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Filters = styled.div<{ $withPartner: boolean }>`
  display: grid;
  grid-template-columns: ${({ $withPartner }) =>
    $withPartner ? "minmax(140px, 1fr) minmax(140px, 1fr) minmax(200px, 2fr)" : "repeat(2, minmax(140px, 240px))"};
  gap: 12px;
  align-items: end;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Totals = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const TotalCard = styled.div<{ $accent?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 20px;
  border: 1px solid ${({ $accent }) => ($accent ? colors.infoBorder : colors.borderSoft)};
  border-radius: 12px;
  background: ${({ $accent }) => ($accent ? colors.infoBg : colors.surface)};
`;

export const TotalLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.textSecondary};
`;

export const TotalAmount = styled.div`
  font-size: 26px;
  font-weight: 700;
  overflow-wrap: anywhere;
  color: ${colors.textPrimary};
`;

export const MutedLine = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

export const TabContent = styled.div`
  margin-top: 20px;
`;

export const DialogForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
